import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
} from '@angular/cdk/drag-drop';
import { TableService } from '../../services/table/table.service';
import * as _ from 'lodash'
import { NgIf, NgFor, NgStyle, NgClass } from '@angular/common';
import { LtmsDropdownComponent } from '../ltms-dropdown/ltms-dropdown.component';
import { LtmsErrorComponent } from '../ltms-error/ltms-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { OrderByPipe } from '../../pipes/order-by/order-by.pipe';
import { shouldShowDeviation } from 'src/app/shared/utils/score-deviation.util';

@Component({
    selector: 'app-ltms-data-table-v2',
    templateUrl: './ltms-data-table-v2.component.html',
    styleUrls: ['./ltms-data-table-v2.component.scss', './ltms-data-table-v2-1366.scss'],
    imports: [NgIf, NgFor, NgStyle, NgClass, LtmsDropdownComponent, LtmsErrorComponent, TranslateModule, OrderByPipe]
})
export class LtmsDataTableV2Component implements OnInit,OnChanges,DoCheck {
  shouldShowDeviation = shouldShowDeviation;
  @Input() configs: any = {};
  @Input() columns: any = [];
  @Input() errorCode: string = '404'
  @Input() data: any = [];
  @Input() footerData: any = {};
  @Input() selectedFilter: any = {}
  @Output() onFilterChange = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onRowSelect = new EventEmitter<any>();
  @Output() onPageChange = new EventEmitter<any>();
  @Output() onRowExpand = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<any>();
  @Output() onChecked = new EventEmitter<any>();
  childConfigs: any = {
    isChildrenTable: true
  }
  isChildrenTable: boolean = false;
  xPositions: number = 0;
  dragPosition: any = { x: 0, y: 0 };
  isDraggingStarted: boolean = false;
  isModalOpen: boolean = false;
  defaultSettings: any = []
  columnsSettings: any = []
  appliedColumns: any = []
  enableApplyButton: boolean = true;
  isFooterEnabled: boolean = false;
  isResizeStart: boolean = false;
  rows: any = []
  isPagingEnabled: boolean = false;
  pagingType: string = "internal";
  pagingDetails: any = {
    "size": 10,
    "page_number": 0,
    "start": 1,
    "end": 10,
    "total": 0,
  }
  isNextDisabled: boolean = false;
  isPreviousDisabled: boolean = false;
  pages: any = [];
  resizeKey: string = '';
  resizeEl: any = null;
  hoverKey: any = null;
  fixedColumns: any = {}
  defaultMaxChar = 40;
  isMaxWidthSet: boolean = false
  tableGroups: any = []
  isSettingsEnabled: boolean = false;
  isCollapsable: boolean = true;
  showCollapsableIcon: boolean = false;
  isRowClickable: boolean = false;
  isExternalSort: boolean = false;
  showConfirmationBox: boolean = false;
  urlLink: any = '';
  confirmationMessageKey: string = 'OUTBOX_NOT_RESPONDED_URL_REDIRECTION_ALERT';
  confirmationMode: 'url' | 'action' | null = null;
  pendingAction: { column: any; row: any } | null = null;
  addEmptyRows:boolean = false;
  minEmptyRows:number = 0
  emptyRows:any = []
  isCheckBoxEnabled:boolean = false;
  @Input() deviationComparisonLabel: string = '';
  @Input() showDeviation = false;
  tooltipElement: HTMLElement | null = null;
  constructor(private _tableService: TableService, private cdr: ChangeDetectorRef) { }

showCustomTooltip(event: MouseEvent, text: string): void {
  if (this.configs?.nativeTooltip) return;
  if (text === undefined || text === null || ( typeof text === 'string' && text?.trim() === '')) return;
  this.hideCustomTooltip(); // remove old tooltip if any 
  this.tooltipElement = document.createElement('div');
  this.tooltipElement.innerText = text;
  this.tooltipElement.style.position = 'fixed';
  this.tooltipElement.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
  this.tooltipElement.style.color = 'white';
  this.tooltipElement.style.padding = '12px';
  this.tooltipElement.style.borderRadius = '10px';
  this.tooltipElement.style.fontSize = '12px';
  this.tooltipElement.style.zIndex = '9999';
  this.tooltipElement.style.maxWidth = '200px';
  this.tooltipElement.style.wordWrap = 'break-word';
  this.tooltipElement.style.pointerEvents = 'none';

  // Temporarily set visibility hidden to measure width
  this.tooltipElement.style.visibility = 'hidden';
  document.body.appendChild(this.tooltipElement);

  const tooltipRect = this.tooltipElement.getBoundingClientRect();
  const spaceRight = window.innerWidth - event.clientX;
  const spaceLeft = event.clientX;

  let top = event.clientY + 10;
  let left: number;

  // If not enough space on the right, show on the left
  if (spaceRight < tooltipRect.width + 10 && spaceLeft > tooltipRect.width + 10) {
    left = event.clientX - tooltipRect.width - 10;
  } else {
    left = event.clientX + 10;
  }
  this.tooltipElement.style.top = `${top}px`;
  this.tooltipElement.style.left = `${left}px`;
  this.tooltipElement.style.visibility = 'visible';
}
  
  hideCustomTooltip(): void {
    if (this.tooltipElement) {
      document.body.removeChild(this.tooltipElement);
      this.tooltipElement = null;
    }
  }

  getDeviationTooltip(deviation: any): string {
    if (this.deviationComparisonLabel) {
      return `vs ${this.deviationComparisonLabel}`;
    }
    return deviation?.deviation ?? '';
  }
  
  ngOnInit() {
    //  this.renderTableData();
  }

  ngOnChanges() { this.renderTableData(); }

  ngDoCheck(): void {
    this.isCheckBoxEnabled = _.get(this.configs, 'checkbox', false)
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }
  renderTableData() {
    this.tableGroups = [];
    this.isMaxWidthSet = false;
    this.isChildrenTable = _.get(this.configs, 'isChildrenTable', false)
    this.addEmptyRows = _.get(this.configs, 'addEmptyRows', false);
    this.minEmptyRows = _.get(this.configs, 'minEmptyRows', 0)
    this.isCheckBoxEnabled = _.get(this.configs, 'checkbox', false)
    this.isPagingEnabled = _.get(this.configs, 'isPagingEnabled', false);
    this.isRowClickable = _.get(this.configs, 'isRowClickable', false);
    this.isExternalSort = _.get(this.configs, 'isExternalSort', false);
    this.isSettingsEnabled = _.get(this.configs, 'isSettingsEnabled', false);
    this.isCollapsable = _.get(this.configs, 'isCollapsable', true);
    this.errorCode = _.get(this.configs, 'errorCode', this.errorCode);
    this.showCollapsableIcon = _.get(this.configs, 'showCollapsableIcon', false);
    this.pagingType = _.get(this.configs, 'pagingType', 'internal')
    this.pagingDetails = _.merge(this.pagingDetails, _.get(this.configs, 'paging', {}));
    this.defaultSettings = this.deepClone(this.columns);
    this.columnsSettings = this.deepClone(this.columns);
    let defaultColumn: any = {}
    this.selectedFilter = (!_.isEmpty(this.selectedFilter)) ? this.selectedFilter : {}
    this.selectedFilter = (typeof this.selectedFilter == 'string') ? JSON.parse(this.selectedFilter) : this.selectedFilter

    const columns = this.deepClone(_.filter(this.columns, (obj: any) => {
      obj.sortingEnabled = (_.hasIn(obj, 'sortingEnabled')) ? _.get(obj, 'sortingEnabled') : true;
      defaultColumn = (_.get(obj, 'isColumnSorted', false)) ? obj : {}
      return obj.enabled == true
    }));
    defaultColumn = _.find(columns,{'isColumnSorted':true});
    if (!_.isEmpty(defaultColumn)) {
      this.sort(defaultColumn,true)
    } else {
      this.setColumns(columns);
    }

    // default sort on first column enable if required in future.
    // if(this.fixedColumns && this.fixedColumns.length){
    //   this.sort(this.fixedColumns[0])
    // }else if(this.appliedColumns && this.appliedColumns.length){
    //   this.sort(this.appliedColumns[0])
    // }
    this.emptyRows = [];
    if(this.addEmptyRows && this.minEmptyRows>0){
      if(this.data && this.data.length <6){
        for(let i = 0;i<=(6 - this.data.length);i++){
          this.emptyRows.push(i)
        }
      }
    }
    
    this.toggelFooter()
    if (this.isPagingEnabled && this.pagingType == 'internal') {
      this.createPaging()
    } else {      
      this.rows = this.deepClone(this.data)
    }
    this.cdr.detectChanges();
    setTimeout(() => {
      this.setWidth();
      this.setHieght();
    }, 50);
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setWidth();
      this.setHieght();
    }, 50);
  }

  setWidth() {
    const container = document.getElementById("data-table-container");
    if (container) {
      const containerRect: any = container.getBoundingClientRect()
      _.each(this.columns, (column: any) => {
        const cellSelector = `.${this.getDataCellClass(column.dataKey)}`;
        let elements = document.querySelectorAll(cellSelector);
        let columnWidth = this._tableService.getWidth(cellSelector)
        if (elements && elements.length > 0) {
          let widthToSet: any = column.style?.width || "";
          if (widthToSet && widthToSet != "") {
            if (typeof widthToSet === 'string' && widthToSet.indexOf('%') !== -1) {
              const pct = parseInt(widthToSet.replace('%', ''), 10);
              columnWidth = containerRect.width * (pct / 100);
            } else if (typeof widthToSet === 'string' && widthToSet.indexOf('px') !== -1) {
              columnWidth = parseInt(widthToSet, 10);
            } else if (!isNaN(Number(widthToSet))) {
              columnWidth = Number(widthToSet);
            }
            this._tableService.updateWidth(cellSelector, columnWidth)
          }
          if (this.showDeviation) {
            let maxContentWidth = columnWidth || 0;
            elements.forEach((el: any) => {
              el.style.whiteSpace = "nowrap";
              el.style.maxWidth = "none";
              el.style.width = "auto";
              el.style.minWidth = "0";
              const wrapper = el.querySelector(".cell-wrapper");
              if (wrapper) {
                wrapper.style.whiteSpace = "nowrap";
              }
              maxContentWidth = Math.max(maxContentWidth, el.scrollWidth);
            });

            const finalWidth = Math.max(columnWidth || 0, maxContentWidth);
            if (finalWidth > 0) {
              elements.forEach((el: any) => {
                el.style.width = finalWidth + "px";
                el.style.minWidth = finalWidth + "px";
              });
            }
          } else {
            elements.forEach((el: any) => {
              el.style.width = columnWidth + "px";
              el.style.maxWidth = columnWidth + "px";
            })
          }

        }
      })
    }

    this.isMaxWidthSet = true;
  }

  setHieght() {
    const firstTableRows: any = document.querySelectorAll('.fisrt-table > .data-table-v2 > .data-table-body > .data-table-row')
    const sectTableRows: any = document.querySelectorAll('.second-table > .data-table-v2 > .data-table-body > .data-table-row')
    if (firstTableRows && sectTableRows) {
      sectTableRows.forEach((element: any, indx: number) => {
        const secRect = element.getBoundingClientRect();
        if (firstTableRows[indx]) {
          const firstRect = firstTableRows[indx].getBoundingClientRect();
          if (firstRect.height < secRect.height) {
            firstTableRows[indx].style.height = secRect.height + "px"
          } else if (firstRect.height > secRect.height) {
            element.style.height = firstRect.height + "px"
          }
        }
      });
    }
  }

  createPaging() {
    this.pages = []
    const rows = this.deepClone(this.data)
    this.pagingDetails.total = rows.length
    this.pagingDetails.start = 1
    if (rows.length <= this.pagingDetails.size) {
      this.isPreviousDisabled = true;
      this.isNextDisabled = true;
      this.rows = rows

      this.pagingDetails.end = rows.length
    } else {
      while (rows.length > 0) {
        const page = rows.splice(0, this.pagingDetails.size);
        this.pages.push(page);
      }
      if (this.pages.length) {
        this.rows = this.pages[0];
      }
      this.isPreviousDisabled = true;
      this.isNextDisabled = false;
      this.pagingDetails.end = this.pagingDetails.size
    }
  }

  toggelFooter() {
    if (!_.isEmpty(this.footerData)) {
      this.isFooterEnabled = true;
    } else {
      this.isFooterEnabled = false;
    }
  }

  /**
   * Description: fire output event whend dropdown value change.
   * @param event 
   */
  onChange(event: any) {
    this.onFilterChange.emit(event)
  }

  /**
   * Description: send row data to parent element.
   * @param column 
   * @param row 
   */
  onSelectValue(column: any, row: any) {
    // console.log("onSelectValue column",column)
    if (column.clickable) {
      const data: any = {
        header: column.header,
        dataKey: column.dataKey,
        row: row
      }
      this.onSelect.emit(data)
    }
  }
  onRowClick(event: any, row: any) {
    if (this.isRowClickable) {
      const data: any = {
        row: row
      }
      this.onRowSelect.emit(data)
    }
  }

  /**
   * Description: Set configuration to resize the column.
   * @param event :mouse event
   * @param column :Object of column
   */
  onMouseDown(event: any, column: any) {
    this.resizeEl = event.target.parentNode
    this.isResizeStart = true;
    this.resizeKey = column.dataKey;
  }

  /**
   * Description: Resize column width on mouse move when isResizeStart flag set to true.
   * @param event 
   */
  onMouseMove(event: any) {
    let table: any;
    if (this.isResizeStart) {
      const table1: any = document.querySelector(".fisrt-table");
      const table2: any = document.querySelector(".second-table");
      if (table1 && table1.contains(this.resizeEl)) {
        table = table1
      } else if (table2 && table2.contains(this.resizeEl)) {
        table = table2
      }
      const rectTable = table.getBoundingClientRect();
      const rect = this.resizeEl.getBoundingClientRect();

      const width = (event.clientX - rect.left) + 5;

      if (84 < width && table) {
        table.style.width = rectTable.width + width + "px"
        //  table.style.minWidth = rectTable.width + width + "px"
        const widthPx = width + "px"
        this.resizeEl.style.width = widthPx;
        this.resizeEl.style.maxWidth = widthPx;
        this.resizeEl.style.minWidth = widthPx;
        const elements = document.querySelectorAll('.data-cell-' + this.resizeKey);
        if (!_.isEmpty(elements)) {
          elements.forEach((el: any) => {
            el.style.width = widthPx;
            el.style.maxWidth = widthPx;
            el.style.minWidth = widthPx;
          });
        }
      }

    }
  }

  /**
   * Description: Disable the resize column.
   * @param event 
   */
  onMouseUp(event: any) {
    this.isResizeStart = false;
  }

  /**
   * Description: Show the left border on mouse over/hover for resize the column
   * @param column : object of specific column
   */
  onMouseOver(column: any) {
    // this.hoverKey = column.dataKey;
    const elements = document.querySelectorAll('.data-cell-' + column.dataKey);
    if (!_.isEmpty(elements)) {
      elements.forEach((el: any) => {
        el.classList.add('resize-border')
      });
    }
  }

  /**
   * Description: Remove the left border when mouse leave the resize area.
   */
  onMouseOut() {
    const elements = document.querySelectorAll('.resize-border');
    if (!_.isEmpty(elements)) {
      elements.forEach((el: any) => {
        el.classList.remove('resize-border')
      });
    }
  }

  toggleCollapseText(event: any, indx: number, row: any, dataKey: string) {
    event.stopPropagation()
    if (!row.collapsableFields) {
      row.collapsableFields = {}
    }
    if (!row.collapsableFields[dataKey]) {
      row.collapsableFields[dataKey] = true
    } else {
      row.collapsableFields[dataKey] = false
    }
    let sourceEl: any;
    let targetEl: any;
    const table1: any = document.querySelector(".fisrt-table");
    const table2: any = document.querySelector(".second-table");
    const firstTableRows: any = document.querySelectorAll('.fisrt-table > .data-table-v2 > .data-table-body > .data-table-row')
    const sectTableRows: any = document.querySelectorAll('.second-table > .data-table-v2 > .data-table-body > .data-table-row')

    if (event.target && table1 && table1.contains(event.target)) {
      sourceEl = firstTableRows[indx]
      targetEl = sectTableRows[indx]
    }
    if (event.target && table2 && table2.contains(event.target)) {
      sourceEl = sectTableRows[indx]
      targetEl = firstTableRows[indx]
    }
    setTimeout(() => {
      if (sourceEl && targetEl) {
        const rect = sourceEl.getBoundingClientRect();
        targetEl.style.height = rect.height + "px";
      }
    }, 0);

  }

  // sorting functionality
  /**
   * Descriptions: This function is used to sort the table data based on column data kay.
   * if data is not sorted by give column then it firt enable the sorting and sort the data in ascending order
   * if data is already sorted for the give column the sort the data in descending order.
   * we can apply sorting for only one column at a time.
   * @param column 
   */
 sort(column: any, isInit?: boolean) {
  if (!this.isExternalSort || (this.isExternalSort && isInit)) {
    let sorted: boolean = false;
    // Update columns with sorting info
    this.columns = _.map(this.columns, (obj: any) => {
      if (obj.sortingEnabled && obj.enabled) {
        if (obj.dataKey == column.dataKey) {
          obj.isColumnSorted = true;
          if (isInit) {
            sorted = obj.sorted;
          } else {
            obj.sorted = !obj.sorted;
            sorted = obj.sorted;
          }
          
        } else {
          obj.isColumnSorted = false;
          delete obj.sorted;
        }
      } else {
        obj.isColumnSorted = false;
        delete obj.sorted;
      }
      // console.log("obj",obj)
      return obj;
    });

    const sortType: string = sorted ? 'desc' : 'asc';
    const sorting_key = column.sortBy || column.dataKey;

    let dataToSort = Helpers.deepClone(this.data);

    // Actual sorting logic
    dataToSort = dataToSort.sort((a, b) => {
      let  nameA = a[sorting_key];
      let  nameB = b[sorting_key];

      // Try parsing both as dates
      const dateA = Date.parse( nameA);
      const dateB = Date.parse( nameB);
      const isDateA = !isNaN(dateA);
      const isDateB = !isNaN(dateB);

      if (isDateA && isDateB) {
        return dateA - dateB;
      }

      // If not dates but strings, apply string comparison with prefix/number logic
      if (typeof  nameA === 'string' && typeof  nameB === 'string') {
        const extractNumber = (str: string) => {
          const match = str.match(/\d+/);
          return match ? parseInt(match[0], 10) : 0;
        };

        const prefixA =  nameA.replace(/\d+/g, '').toUpperCase();
        const prefixB =  nameB.replace(/\d+/g, '').toUpperCase();

        if (prefixA < prefixB) return -1;
        if (prefixA > prefixB) return 1;

        const numA = extractNumber( nameA);
        const numB = extractNumber( nameB);
        return numA - numB;
      }
      // Fallback numeric comparison
      if ( nameA <  nameB) return -1;
      if ( nameA >  nameB) return 1;
      return 0;
    });

    // Reverse if descending
    if (sortType === 'desc') {
      dataToSort = dataToSort.reverse();
    }

    this.data = dataToSort;
    // this.data = _.orderBy(this.data, [sorting_key], [sortType]); 
    if (this.isPagingEnabled && this.pagingType === 'internal') {
      this.createPaging();
    } else {
      this.rows = this.deepClone(this.data);
    }
    this.setColumns(this.columns);
  } else {
    const columnSort: any = Helpers.deepClone(column);
    columnSort.sorted = !columnSort.sorted;
    this.onSort.emit(columnSort);
  }
}

  setColumns(columns: any) {
    this.tableGroups = [];
    if (!this.isCollapsable) {
      this.fixedColumns = _.filter(this.deepClone(columns), (object: any) => {
        return object.fixed == true;
      })
      this.appliedColumns = _.filter(this.deepClone(columns), (object: any) => {
        return (!('fixed' in object) || object.fixed != true);
      })
      if (this.fixedColumns && this.fixedColumns.length) {
        this.tableGroups.push({
          "tableid": "fisrt-table",
          "className": "fisrt-table",
          isSettingsEnabled: this.isSettingsEnabled,
          "order": 1,
          "columns": this.fixedColumns,
        })
      }
      if (this.appliedColumns && this.appliedColumns.length) {
        this.tableGroups.push({
          "tableid": "second-table",
          "className": "second-table",
          isSettingsEnabled: (!(this.fixedColumns && this.fixedColumns.length) && this.isSettingsEnabled),
          "order": 2,
          "columns": this.appliedColumns,
        })
      }

    } else {
      this.appliedColumns = this.deepClone(columns)
      if (this.appliedColumns && this.appliedColumns.length) {
        this.tableGroups.push({
          "tableid": "second-table",
          "className": "second-table",
          isSettingsEnabled: (this.isSettingsEnabled),
          "order": 2,
          "columns": this.appliedColumns,
        })
      }
    }
  }

  // drag and drop functionality implemented here
  // TODO: Drag and Drop functionality should be implemeted to re order the columns.
  moveCol(event: any, column?: any) {
    // const dataIndex = _.findIndex(this.columns,{header:column.header,dataKey:column.dataKey})

    this.xPositions = event.distance.x;
    const data = event.source.data;
    const element = event.source.element.nativeElement;
    element.style.whiteSpace = "nowrap"
    element.style.transform = `translate3d(${event.distance.x}px, 0px, 0px)`;
    this.dragPosition = { x: event.distance.x, y: event.distance.y };
    const elements: any = document.querySelectorAll('.data-cell-' + data.dataKey)

    if (!_.isEmpty(elements)) {
      if (!this.isDraggingStarted) {
        this.isDraggingStarted = true;
        _.each(elements, (el: any) => {
          el.classList.add('dragging')
          el.style.transform = `translate3d(${event.distance.x}px,0px,0px)`
        })
      }
      _.each(elements, (el: any) => {
        el.classList.add('dragging')
        el.style.transform = `translate3d(${event.distance.x}px,0px,0px)`
      })
    }
  }

  dropCol(event: any) {
    const data = event.item.data;
    const elements: any = document.querySelectorAll('.data-cell-' + data.dataKey)
    document.querySelectorAll(".placeholder").forEach(e => e.remove());
    this.isDraggingStarted = false;
    if (!_.isEmpty(elements)) {
      _.each(elements, (el: any) => {
        el.classList.remove('dragging')
        el.style.transform = ``
      })
    }
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  // list view settings
  /**
   * Description: This function open list view settings modal to change the visiblity of table columns.
   */
  openModal() {
    this.isModalOpen = true;
  }

  /**
   * Description: This function close list view settings modal .
   */
  closeModal() {
    this.isModalOpen = false;
  }

  /**
   * Description: This function enable or disable the columns from table .
   * @param column : column is an object which has configuration of column specific.
   */
  setColumnsVisiblity(column: any) {
    let order: number = _.size(_.filter(this.columnsSettings, (obj: any) => {
      return obj.enabled == true
    }));

    this.columnsSettings = _.map(this.columnsSettings, (obj: any) => {
      if (obj.dataKey == column.dataKey) {
        // obj.order = order;
        obj.enabled = !column.enabled;
      }
      return obj;
    })

    this.checkSelectedColumns()
  }

  /**
   * Description: This function will reset the column visiblity to default.
   */
  setDefaultValue() {
    this.columnsSettings = this.deepClone(this.defaultSettings)
    this.checkSelectedColumns()
  }

  /**
   * Description: This function will set the column to be  visible in table.
   */
  selectAllField() {
    this.columnsSettings = _.map(this.columnsSettings, (obj: any) => {
      if (obj.enabled != true) {
        obj.enabled = true
      }
      return obj;
    })
    this.checkSelectedColumns()

  }

  /**
   * Description: This function will set the column to be  hide in table.
   * Condition: at least one column visiblitys set tu true to apply the list view settings
   */
  deselectAllField() {
    this.columnsSettings = _.map(this.columnsSettings, (obj: any) => {
      obj.enabled = false;
      return obj;
    })

    this.checkSelectedColumns()
  }

  /**
  * Description: This function is used to enable or disable the apply button by checking visible columns.
  * Condition: at least one column visiblitys set tu true to apply the list view settings
  */
  private checkSelectedColumns() {
    const data = _.filter(this.columnsSettings, (obj: any) => {
      return obj.enabled == true
    })
    if (!_.isEmpty(data)) {
      this.enableApplyButton = true
    } else {
      this.enableApplyButton = false
    }
  }

  /**
   * Description: This function is used to apply changed list view setting to table.
   */
  applyColumnSetting() {
    // this.columns = JSON.parse(JSON.stringify(this.columnsSettings))
    const columns = this.deepClone(_.filter(this.columnsSettings, (obj: any) => {
      return obj.enabled == true
    }))
    this.setColumns(columns)
    this.appliedColumns.splice(0, 1)
    this.closeModal()
  }


  changePage(eventType: string) {
    if (this.pagingType == "internal") {
      let page_number = this.pagingDetails.page_number
      if (eventType == 'first') {
        page_number = 0
      } else if (eventType == 'last') {
        page_number = this.pages.length - 1
      } else if (eventType == 'next' && page_number < this.pages.length - 1) {
        page_number = page_number + 1
      } else if (eventType == 'previous' && page_number > 0) {
        page_number = page_number - 1
      }

      this.pagingDetails.start = (page_number * this.pagingDetails.size) + 1;
      this.pagingDetails.end = (page_number * this.pagingDetails.size) + this.pagingDetails.size

      this.pagingDetails.page_number = page_number;
      this.rows = this.pages[page_number];
      if (this.rows.length < this.pagingDetails.size) {
        this.pagingDetails.end = this.pagingDetails.total
      }
      if (page_number == this.pages.length - 1) {
        this.isNextDisabled = true
      } else {
        this.isNextDisabled = false
      }

      if (page_number == 0) {
        this.isPreviousDisabled = true;
      } else {
        this.isPreviousDisabled = false;
      }
    } else {
      const event = {
        eventType: eventType,
        pagingDetails: this.pagingDetails
      }

      this.onPageChange.emit(event)
    }

  }

  /**
  * Description: This function is used cloning the object data.
  */
  private deepClone(object: any) {
    return JSON.parse(JSON.stringify(object))
  }

  enableCollapseButton(column: any, value: any) {
    let flag: boolean = false;
    if (column.ellipsisEnabled && column.dataType == 'string') {
      if (column.maxChar < value.length) {
        flag = true;
      }
    }
    return flag;
  }

  getColor(column: any, row: any, dataKey: string) {
    let color = '';
    if (row && row.coloMap && row.coloMap[dataKey]) {
      color = row.coloMap[dataKey]
    } else if (column && column.style && column.style.cellTextColor) {
      color = column.style.cellTextColor;
    }
    return color
  }

  expandRow(column: any, row: any, indx: number) {

    if (!row.isExpanded) {
      row.isExpanded = true;
    } else {
      row.isExpanded = false;
    }
    if (row.isExpanded) {
      this.onRowExpand.emit({
        row: row,
        index: indx
      })
    }
  }
  
  toggleCheck(event:any,row:any){
    event.preventDefault();
    if(row.selected){
      row.selected = false;
    }else{
      row.selected = true;
    }
    this.onChecked.emit(row);
  }

  isDataExistsForCoumn(data) {
    return typeof data != 'undefined';
  }

  isBadgesComponent(column: any) {
    const flag = ((column.componentType == 'badges' || column.componentType == 'status') && (column.dataType == 'number' || column.dataType == 'string'));
    return flag
  }

  isHtmlExists(column: any) {
    return column.isHtmlExist && (!column.componentType || (column.componentType == 'badges' && column.dataType != 'number') || (column.componentType == 'status' && column.dataType != 'string'));
  }

  isDefaultType(column: any) {
    return !column.isInfoIconVisible && !column.isHtmlExist && (!column.componentType || (column.componentType == 'badges' && column.dataType != 'number') || (column.componentType == 'status' && column.dataType != 'string'));
  }

  isInfoType(column: any) {
    return column.isInfoIconVisible && !column.isHtmlExist && (!column.componentType || (column.componentType == 'badges' && column.dataType != 'number') || (column.componentType == 'status' && column.dataType != 'string'));
  }

  isTextEllipsisType(column: any) {
    return ((column.dataType == 'string' || !column.dataType) && column.componentType == 'collapsable');
  }

  ellipsisText(column: any, text: string) {
    if (this.isTextEllipsisType(column)) {
      return text.substring(0, column.maxChar - 1)
    } else {
      return text
    }
  }

  getkey(dataKey: string, value: string) {
    return btoa(unescape(encodeURIComponent(dataKey + "_" + value)))
  }

  getEllpsisId(column: any, row: any) {
    return 'ellipsis-' + this.getkey(column.dataKey, row[column.dataKey])
  }

  isEllipsisActive(column, row) {
    const id = 'ellipsis-' + this.getkey(column.dataKey, row[column.dataKey]);
    const el = document.getElementById(id);
    if (el) {
      return (el.offsetWidth < el.scrollWidth)
    } else {
      return false
    }

  }
  alertRedirectURL(href, event) {
    event.stopPropagation();
    this.confirmationMode = 'url';
    this.confirmationMessageKey = 'OUTBOX_NOT_RESPONDED_URL_REDIRECTION_ALERT';
    this.pendingAction = null;
    this.urlLink = href;
    this.showConfirmationBox = true;
  }

  onActionButtonClick(column: any, row: any, event: Event) {
    event.stopPropagation();
    // Expired rows stay clickable so Outbox can open channel panel for trial history.
    if (!column?.requireConfirmation || row?.isOnDemandExpired) {
      this.emitActionButtonSelect(column, row);
      return;
    }
    this.confirmationMode = 'action';
    this.confirmationMessageKey = column.confirmMessageKey || 'OUTBOX_ON_DEMAND_SEND_ALERT';
    this.pendingAction = { column, row };
    this.showConfirmationBox = true;
  }

  emitActionButtonSelect(column: any, row: any) {
    this.onSelect.emit({
      header: column.header,
      dataKey: column.dataKey,
      row,
      action: column.source_type
    });
  }

  confirmModalProceed() {
    if (this.confirmationMode === 'url') {
      this.redirectURL();
      return;
    }
    if (this.confirmationMode === 'action' && this.pendingAction) {
      this.emitActionButtonSelect(this.pendingAction.column, this.pendingAction.row);
    }
    this.closeRedirectURLModal();
  }

  closeRedirectURLModal() {
    this.showConfirmationBox = false;
    this.urlLink = '';
    this.confirmationMode = null;
    this.pendingAction = null;
  }

  redirectURL(): void {
    window.open(this.urlLink, '_blank');
    this.closeRedirectURLModal();
  }
  copyToClipboard(value: any, event: Event): void {
    event.stopPropagation();
    navigator.clipboard.writeText(value);
    Helpers.smallAlertBox('Success', 'Copied to clipboard', 'success', 2000);
  }
  /**
   * Get full header text for tooltip
   */
  getFullHeaderText(column: any): string {
    return column?.header || '';
  }

  getDataCellClass(dataKey: any): string {
    return 'data-cell-' + String(dataKey || '').replace(/\s+/g, '-');
  }
}
